module.exports = __webpack_public_path__ + "static/media/29EUNOG15.2dc29ba0.jpg";